import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IProduit } from 'app/shared/model/produit.model';
import { getEntities as getProduits } from 'app/entities/produit/produit.reducer';
import { IDevis } from 'app/shared/model/devis.model';
import { getEntities as getDevis } from 'app/entities/devis/devis.reducer';
import { ILigneProduit } from 'app/shared/model/ligne-produit.model';
import { getEntity, updateEntity, createEntity, reset } from './ligne-produit.reducer';

export const LigneProduitUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const produits = useAppSelector(state => state.produit.entities);
  const devis = useAppSelector(state => state.devis.entities);
  const ligneProduitEntity = useAppSelector(state => state.ligneProduit.entity);
  const loading = useAppSelector(state => state.ligneProduit.loading);
  const updating = useAppSelector(state => state.ligneProduit.updating);
  const updateSuccess = useAppSelector(state => state.ligneProduit.updateSuccess);

  const handleClose = () => {
    navigate('/ligne-produit' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getProduits({}));
    dispatch(getDevis({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  // eslint-disable-next-line complexity
  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.quantiteCommandee !== undefined && typeof values.quantiteCommandee !== 'number') {
      values.quantiteCommandee = Number(values.quantiteCommandee);
    }
    values.datePersistence = convertDateTimeToServer(values.datePersistence);
    values.dateUpdate = convertDateTimeToServer(values.dateUpdate);

    const entity = {
      ...ligneProduitEntity,
      ...values,
      produit: produits.find(it => it.id.toString() === values.produit?.toString()),
      devis: devis.find(it => it.id.toString() === values.devis?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          datePersistence: displayDefaultDateTime(),
          dateUpdate: displayDefaultDateTime(),
        }
      : {
          ...ligneProduitEntity,
          datePersistence: convertDateTimeFromServer(ligneProduitEntity.datePersistence),
          dateUpdate: convertDateTimeFromServer(ligneProduitEntity.dateUpdate),
          produit: ligneProduitEntity?.produit?.id,
          devis: ligneProduitEntity?.devis?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="alexisExportApp.ligneProduit.home.createOrEditLabel" data-cy="LigneProduitCreateUpdateHeading">
            <Translate contentKey="alexisExportApp.ligneProduit.home.createOrEditLabel">Create or edit a LigneProduit</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="ligne-produit-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('alexisExportApp.ligneProduit.quantiteCommandee')}
                id="ligne-produit-quantiteCommandee"
                name="quantiteCommandee"
                data-cy="quantiteCommandee"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('alexisExportApp.ligneProduit.datePersistence')}
                id="ligne-produit-datePersistence"
                name="datePersistence"
                data-cy="datePersistence"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('alexisExportApp.ligneProduit.dateUpdate')}
                id="ligne-produit-dateUpdate"
                name="dateUpdate"
                data-cy="dateUpdate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                id="ligne-produit-produit"
                name="produit"
                data-cy="produit"
                label={translate('alexisExportApp.ligneProduit.produit')}
                type="select"
              >
                <option value="" key="0" />
                {produits
                  ? produits.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="ligne-produit-devis"
                name="devis"
                data-cy="devis"
                label={translate('alexisExportApp.ligneProduit.devis')}
                type="select"
              >
                <option value="" key="0" />
                {devis
                  ? devis.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/ligne-produit" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};
export default LigneProduitUpdate;
